import { render, staticRenderFns } from "./DocId.vue?vue&type=template&id=0cdc282b&scoped=true"
import script from "./DocId.vue?vue&type=script&lang=js"
export * from "./DocId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdc282b",
  null
  
)

export default component.exports